<template>
    <CardShell>

        <h4 class="pv4 tc bg-white bb b--light-gray">{{contact.display_name}}</h4>

        <div class="bg-near-white">
            <HugeSpinner v-if="loadingMessages"/>
            <div v-else>
                <div class="pt4">
                    <div class="mh4">
                        <Messages></Messages>
                    </div>
                </div>
                <SendMessage :contactId="contact.id" class="bg-white"/>
            </div>
        </div>
    </CardShell>
</template>

<script>
import Messages from '@/components/inbox/Messages.vue';
import CardShell from '@/components/global/CardShell.vue';
import SendMessage from '@/components/inbox/messagesCard/shared/SendMessage.vue';
import HugeSpinner from '@/components/controls/HugeSpinner.vue';
import { mapState, mapGetters } from 'vuex';

export default {
    components: {
        Messages,
        CardShell,
        SendMessage,
        HugeSpinner
    },
    computed: {
        ...mapState('messages', ['loadingMessages']),
        ...mapGetters('messages', ['contact'])
    }
};
</script>
